









import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator';

/* USAGE

template:
  <BeforeChangeWrapper
    :variable.sync="myInputValue"
    :before-change="(value, apply, revert) => value != '123' ? apply() : revert()"
  >
    <template v-slot="{ variable, setVariable }">
      <s-input
        v-model="variable"
        @input="setVariable"
      />
    </template>
  </BeforeChangeWrapper>

script:
  private myInputValue: string = '';

*/

type beforeChangeFunction<T> = (value: T, apply: (() => void), revert: (() => void)) => void;

@Component
export default class BeforeChangeWrapper<T> extends Vue {
  @PropSync('variable', { required: true }) private originalVariable!: T;
  @Prop({ type: Function, required: true }) private beforeChange!: beforeChangeFunction<T> ;

  private internalVariable: T | null = null;

  @Watch('originalVariable', { immediate: true })
  private setInternalVariable(): void {
    this.internalVariable = this.originalVariable;
  }

  private setVariable(value: T): void {
    this.internalVariable = value;

    this.$nextTick(() => {
      this.beforeChange(this.internalVariable!, this.apply, this.revert);
    });
  }

  private apply(): void {
    this.originalVariable = this.internalVariable!;
  }

  private revert(): void {
    this.internalVariable = this.originalVariable!;
  }
}
